module.exports = __webpack_public_path__ + "/images/shop/icon/chevron_right--picton-blue.svg";